import React, { useState, useEffect } from 'react';
import { TextField, DefaultButton, Label } from '@fluentui/react';
import './Event.css';

export function AdditionalGuest(props) {
    const [guestList, setGuestList] = useState([]);

    useEffect(() => {
        props.guestListCallback(guestList);
    }, [guestList]);

    const onAddButtonClicked = () => {
        const newGuest = {
            key: new Date().getTime(),
            LastName: '',
            FirstName: ''
        };

        setGuestList(oldList => [...oldList, newGuest])
    };

    const onDeleteButtonClicked = (key) => {
        let updatedList = guestList.filter((item) => item.key !== key)
        setGuestList(updatedList);
    };

    const onFirstNameChanged = (key, newValue) => {
        const updatedList = guestList.map((item) => {
            if (item.key === key) {
                item.FirstName = newValue;
            }
            return item;
        });

        setGuestList(updatedList);
    };

    const onLastNameChanged = (key, newValue) => {
        const updatedList = guestList.map((item) => {
            if (item.key === key) {
                item.LastName = newValue;
            }
            return item;
        });

        setGuestList(updatedList);
    };

    return (
        <div className="childComponent">
            <Label>You may add additional guest(s) up to {props.maxGuest}.</Label>
            <hr/>
            {guestList.map((item) => (
                <div>                    
                    <div className="divDeleteButton"><button title="Delete" className="deleteButton"  onClick={() => onDeleteButtonClicked(item.key)} >x</button></div>
                    <br/>
                    <TextField required label="First Name" value={item.FirstName} onChange={(event, newValue) => onFirstNameChanged(item.key, newValue)} />
                    <TextField required label="Last Name" value={item.LastName} onChange={(event, newValue) => onLastNameChanged(item.key, newValue)} />
                    <br />
                </div>
            ))}
            {props.maxGuest <= guestList.length ? null :
                <div><DefaultButton text="Add Guest" onClick={onAddButtonClicked} /></div>
            }
            <hr />
        </div>          
    );
}